if (!customElements.get('image-gallery-slider')) {
  customElements.define(
    'image-gallery-slider',
    class ImageGallerySlider extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.sliderWrapper = this.querySelector('.image-gallery-slider__items');

        // Handle design mode block selection
        if (Shopify.designMode) {
          document.addEventListener('shopify:block:select', (e) => {
            if (e.detail.sectionId != this.sectionId) return;
            const { target } = e;
            const index = Number(target.dataset.index);
            const item = this.sliderWrapper.children[index];
            if (item) {
              item.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
            }
          });
        }
      }
    }
  );
}

if (!customElements.get('image-gallery-scroll-progress-bar')) {
  customElements.define(
    'image-gallery-scroll-progress-bar',
    class ImageGalleryScrollProgressBar extends ScrollProgressBar {
      get totalWidth() {
        this.allChildren = this.target.children;
        let totalWidth = 0;
        [...this.allChildren].forEach((child) => {
          totalWidth += child.offsetWidth;
        });
        return totalWidth;
      }
    }
  );
}
